module.exports = __webpack_public_path__ + "img/category-sport-hover.cf22c565.png";